import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// Поповер настройки колонок таблицы посетителей:
// галочка — показывать/скрывать колонку, стрелки — менять порядок.
const ColumnSettings = props => {
  const { anchorEl, open, onClose, items, onToggle, onMove } = props;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Typography variant='subtitle2' sx={{ px: 2, pt: 1.5 }}>
        Отображаемые поля
      </Typography>
      <List dense sx={{ minWidth: 280 }}>
        {items.map((item, index) => (
          <ListItem
            key={item.id}
            secondaryAction={
              <>
                <IconButton
                  edge='end'
                  size='small'
                  aria-label='Выше'
                  disabled={index === 0}
                  onClick={() => onMove(item.id, -1)}
                >
                  <KeyboardArrowUpIcon fontSize='small' />
                </IconButton>
                <IconButton
                  edge='end'
                  size='small'
                  aria-label='Ниже'
                  disabled={index === items.length - 1}
                  onClick={() => onMove(item.id, 1)}
                >
                  <KeyboardArrowDownIcon fontSize='small' />
                </IconButton>
              </>
            }
          >
            <Checkbox edge='start' checked={item.visible} onChange={() => onToggle(item.id)} />
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Popover>
  );
};

ColumnSettings.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  items: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
};

export default ColumnSettings;
